// Generated by scripts/referentiel/extract.mjs — do not edit by hand.
//
// 676 attendus of the P3 tronc commun, from the nine référentiels
// published by the Fédération Wallonie-Bruxelles.

export type { Attendu } from './types.ts';
import { ATTENDUS as ATTENDUS_FRANCAIS } from './francais.ts';
import { ATTENDUS as ATTENDUS_MATHEMATIQUES } from './mathematiques.ts';
import { ATTENDUS as ATTENDUS_EVEIL_SCIENTIFIQUE } from './eveil-scientifique.ts';
import { ATTENDUS as ATTENDUS_EVEIL_HISTORIQUE } from './eveil-historique.ts';
import { ATTENDUS as ATTENDUS_EVEIL_GEOGRAPHIQUE } from './eveil-geographique.ts';
import { ATTENDUS as ATTENDUS_FORMATION_ECONOMIQUE_ET_SOCIALE } from './formation-economique-et-sociale.ts';
import { ATTENDUS as ATTENDUS_FORMATION_MANUELLE_TECHNIQUE_TECHNOLOGIQUE_ET_NUMERIQUE } from './formation-manuelle-technique-technologique-et-numerique.ts';
import { ATTENDUS as ATTENDUS_EDUCATION_CULTURELLE_ET_ARTISTIQUE } from './education-culturelle-et-artistique.ts';
import { ATTENDUS as ATTENDUS_EDUCATION_PHYSIQUE_BIEN_ETRE_ET_SANTE } from './education-physique-bien-etre-et-sante.ts';
import { ATTENDUS as ATTENDUS_EDUCATION_A_LA_PHILOSOPHIE_ET_A_LA_CITOYENNETE } from './education-a-la-philosophie-et-a-la-citoyennete.ts';
import { ATTENDUS as ATTENDUS_LANGUES_MODERNES } from './langues-modernes.ts';
import type { Attendu } from './types.ts';

/** Attendus of every subject the tronc commun covers, keyed by subject name. */
export const ATTENDUS_BY_SUBJECT: Readonly<Record<string, readonly Attendu[]>> = {
  "Français": ATTENDUS_FRANCAIS,
  "Mathématiques": ATTENDUS_MATHEMATIQUES,
  "Éveil scientifique": ATTENDUS_EVEIL_SCIENTIFIQUE,
  "Éveil historique": ATTENDUS_EVEIL_HISTORIQUE,
  "Éveil géographique": ATTENDUS_EVEIL_GEOGRAPHIQUE,
  "Formation économique et sociale": ATTENDUS_FORMATION_ECONOMIQUE_ET_SOCIALE,
  "Formation manuelle, technique, technologique et numérique": ATTENDUS_FORMATION_MANUELLE_TECHNIQUE_TECHNOLOGIQUE_ET_NUMERIQUE,
  "Éducation culturelle et artistique": ATTENDUS_EDUCATION_CULTURELLE_ET_ARTISTIQUE,
  "Éducation physique, bien-être et santé": ATTENDUS_EDUCATION_PHYSIQUE_BIEN_ETRE_ET_SANTE,
  "Éducation à la philosophie et à la citoyenneté": ATTENDUS_EDUCATION_A_LA_PHILOSOPHIE_ET_A_LA_CITOYENNETE,
  "Langues modernes": ATTENDUS_LANGUES_MODERNES,
};
